import './HeaderMobile.scss';

const HeaderMobile = ({ logo }) => {
  return (
    <>
      <div className="header-mobile__spacer"></div>
      <header className="header-mobile header-mobile-bg">
        <img
          src={logo}
          width={48}
          height={48}
          className="header-mobile__logo"
          alt="Logo Itaú"
        />
      </header>
    </>
  );
};

export default HeaderMobile;
